import React, { useEffect, useMemo, useState } from "react";
import { buildApiEndpoint } from "../../shared/config/apiConfig";

const Styles = () => (
  <style>{`
    .pkg-page { color: #F9FAFB; }
    .pkg-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem; margin-bottom: 1.4rem; }
    .pkg-title { font-size: 2rem; font-weight: 800; margin: 0; }
    .pkg-subtitle { color: #94A3B8; margin-top: 0.35rem; font-size: 0.9rem; }
    .pkg-actions { display: flex; gap: 0.75rem; flex-wrap: wrap; }
    .pkg-btn { border: 0; border-radius: 10px; padding: 0.72rem 1.15rem; font-weight: 800; cursor: pointer; color: #fff; }
    .pkg-btn-primary { background: linear-gradient(135deg, #6366F1, #4F46E5); box-shadow: 0 12px 28px rgba(79,70,229,0.25); }
    .pkg-btn-secondary { background: #334155; border: 1px solid #475569; }
    .pkg-btn-danger { color: #FCA5A5; background: rgba(239,68,68,0.1); border: 1px solid rgba(239,68,68,0.25); }
    .pkg-summary-grid { display: grid; grid-template-columns: repeat(5, minmax(150px, 1fr)); gap: 1rem; margin-bottom: 1.25rem; }
    .pkg-stat { background: linear-gradient(135deg, #111827, #0F172A); border: 1px solid #243244; border-radius: 14px; padding: 1rem; }
    .pkg-stat-label { color: #94A3B8; font-size: 0.75rem; text-transform: uppercase; letter-spacing: 0.08em; font-weight: 800; }
    .pkg-stat-value { font-size: 1.35rem; font-weight: 900; margin-top: 0.45rem; color: #F8FAFC; }
    .pkg-trend { background: #0F172A; border: 1px solid #243244; border-radius: 14px; padding: 1rem; margin-bottom: 1.25rem; }
    .pkg-trend-title { font-weight: 800; margin-bottom: 0.75rem; color: #E5E7EB; }
    .pkg-bars { display: flex; align-items: flex-end; gap: 0.75rem; height: 115px; overflow-x: auto; padding: 0.5rem 0.2rem; }
    .pkg-bar-wrap { min-width: 66px; display: flex; flex-direction: column; align-items: center; gap: 0.45rem; }
    .pkg-bar { width: 28px; min-height: 8px; border-radius: 8px 8px 2px 2px; background: linear-gradient(180deg, #22D3EE, #4F46E5); }
    .pkg-bar-label { font-size: 0.72rem; color: #94A3B8; }
    .pkg-bar-value { font-size: 0.72rem; color: #E5E7EB; font-weight: 800; }
    .pkg-table-wrap { background: #111827; border: 1px solid #243244; border-radius: 14px; overflow-x: auto; }
    .pkg-table { width: 100%; border-collapse: collapse; }
    .pkg-table th, .pkg-table td { padding: 1rem 1.15rem; border-bottom: 1px solid #243244; white-space: nowrap; text-align: left; color: #F8FAFC; }
    .pkg-table th { color: #CBD5E1; font-size: 0.75rem; text-transform: uppercase; letter-spacing: 0.08em; }
    .pkg-name { font-weight: 900; color: #F8FAFC; }
    .pkg-code { margin-top: 0.3rem; font-size: 0.74rem; color: #38BDF8; font-weight: 800; }
    .pkg-muted { color: #94A3B8; font-size: 0.82rem; }
    .pkg-badge { display: inline-flex; align-items: center; border-radius: 999px; padding: 0.28rem 0.7rem; font-weight: 900; font-size: 0.76rem; }
    .pkg-badge-active { background: rgba(34,197,94,0.15); color: #86EFAC; }
    .pkg-badge-inactive { background: rgba(239,68,68,0.14); color: #FCA5A5; }
    .pkg-badge-published { background: rgba(59,130,246,0.16); color: #93C5FD; margin-left: 0.35rem; }
    .pkg-row-actions { display: flex; gap: 0.55rem; }
    .pkg-mini-btn { border-radius: 8px; border: 1px solid #334155; background: #1E293B; color: #E5E7EB; padding: 0.48rem 0.7rem; cursor: pointer; font-weight: 800; }
    .pkg-pagination { display: flex; justify-content: flex-end; align-items: center; gap: 0.75rem; padding: 1rem 0; color: #CBD5E1; }
    .pkg-pagination button { background: #1E293B; color: #fff; border: 1px solid #334155; border-radius: 8px; padding: 0.55rem 0.9rem; cursor: pointer; }
    .pkg-pagination button:disabled { opacity: 0.45; cursor: not-allowed; }
    .pkg-alert { background: rgba(239,68,68,0.12); color: #FECACA; border: 1px solid rgba(239,68,68,0.25); padding: 0.85rem 1rem; border-radius: 12px; margin-bottom: 1rem; }
    .pkg-modal-bg { position: fixed; inset: 0; background: rgba(0,0,0,0.72); z-index: 1002; display: flex; align-items: center; justify-content: center; padding: 1rem; }
    .pkg-modal { width: min(820px, 95vw); max-height: 92vh; overflow-y: auto; background: #111827; border: 1px solid #334155; border-radius: 16px; padding: 1.4rem; box-shadow: 0 24px 80px rgba(0,0,0,0.45); }
    .pkg-modal-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.2rem; }
    .pkg-modal-title { margin: 0; font-size: 1.4rem; font-weight: 900; }
    .pkg-close { background: transparent; color: #CBD5E1; border: 0; font-size: 1.9rem; cursor: pointer; }
    .pkg-form-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1rem; }
    .pkg-form-group { display: flex; flex-direction: column; gap: 0.45rem; }
    .pkg-form-group.full { grid-column: 1 / -1; }
    .pkg-label { font-size: 0.82rem; color: #CBD5E1; font-weight: 800; }
    .pkg-input, .pkg-textarea { width: 100%; border-radius: 10px; border: 1px solid #334155; background: #0F172A; color: #F8FAFC; padding: 0.75rem 0.85rem; font-size: 0.95rem; }
    .pkg-textarea { min-height: 88px; resize: vertical; }
    .pkg-checks { display: flex; gap: 1.2rem; align-items: center; flex-wrap: wrap; margin-top: 0.4rem; }
    .pkg-checks label { color: #CBD5E1; font-weight: 800; display: flex; gap: 0.45rem; align-items: center; }
    @media (max-width: 1100px) { .pkg-summary-grid { grid-template-columns: repeat(2, minmax(150px, 1fr)); } }
    @media (max-width: 720px) { .pkg-header { flex-direction: column; } .pkg-summary-grid, .pkg-form-grid { grid-template-columns: 1fr; } }
  `}</style>
);

const authHeaders = (json = false) => {
  const headers = { Authorization: `Bearer ${localStorage.getItem("authToken") || ""}` };
  if (json) headers["Content-Type"] = "application/json";
  return headers;
};

const apiService = {
  async getLinkedSummary() {
    const response = await fetch(buildApiEndpoint("/packages/admin/linked-summary"), {
      headers: authHeaders(),
    });
    if (!response.ok) throw new Error(await response.text() || "Failed to fetch linked package summary.");
    return response.json();
  },
  async getFallbackPackages() {
    const response = await fetch(buildApiEndpoint("/packages?page=0&size=500&sortBy=createdAt&sortDir=desc"), {
      headers: authHeaders(),
    });
    if (!response.ok) throw new Error(await response.text() || "Failed to fetch packages.");
    const data = await response.json();
    return {
      source: "old-backend-local",
      packages: Array.isArray(data) ? data : data.content || [],
      totalPackages: data.totalElements || data.content?.length || 0,
      activePackages: (data.content || []).filter((p) => getActive(p)).length,
      totalPackageInvested: 0,
      investmentTrend: [],
    };
  },
  async createPackage(payload) {
    const response = await fetch(buildApiEndpoint("/packages/admin/create-json"), {
      method: "POST",
      headers: authHeaders(true),
      body: JSON.stringify(payload),
    });
    if (!response.ok) throw new Error(await response.text() || "Failed to create package.");
    return response.json();
  },
  async updatePackage(id, payload) {
    const response = await fetch(buildApiEndpoint(`/packages/admin/${id}`), {
      method: "PUT",
      headers: authHeaders(true),
      body: JSON.stringify(payload),
    });
    if (!response.ok) throw new Error(await response.text() || "Failed to update package.");
    return response.json();
  },
  async deletePackage(id) {
    const response = await fetch(buildApiEndpoint(`/packages/admin/${id}`), {
      method: "DELETE",
      headers: authHeaders(),
    });
    if (!response.ok) throw new Error(await response.text() || "Failed to delete package.");
  },
};

const getActive = (pkg) => pkg?.active ?? pkg?.isActive ?? true;
const getPublished = (pkg) => pkg?.published ?? pkg?.featured ?? pkg?.isFeatured ?? false;
const safeText = (value) => (value === null || value === undefined || String(value).trim() === "" ? "-" : String(value));
const safeNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};
const optionalNumber = (value) => {
  if (value === "" || value === null || value === undefined) return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};
const money = (value) => {
  if (value === null || value === undefined || value === "") return "₹0";
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  return `₹${n.toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
};

const StatCard = ({ label, value }) => (
  <div className="pkg-stat">
    <div className="pkg-stat-label">{label}</div>
    <div className="pkg-stat-value">{value}</div>
  </div>
);

const TrendBars = ({ trend = [] }) => {
  if (!Array.isArray(trend) || trend.length === 0) return null;
  const max = Math.max(...trend.map((row) => safeNumber(row.amount)), 1);
  return (
    <div className="pkg-trend">
      <div className="pkg-trend-title">Investment Trend</div>
      <div className="pkg-bars">
        {trend.map((row, idx) => {
          const amount = safeNumber(row.amount);
          const height = Math.max(8, Math.round((amount / max) * 88));
          return (
            <div className="pkg-bar-wrap" key={`${row.month || idx}-${idx}`}>
              <div className="pkg-bar-value">{money(amount)}</div>
              <div className="pkg-bar" style={{ height }} />
              <div className="pkg-bar-label">{row.month || "-"}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const PackageFormModal = ({ isOpen, initialData, onClose, onSave, saving }) => {
  const [form, setForm] = useState({});

  useEffect(() => {
    setForm({
      name: initialData?.name || "",
      packageCode: initialData?.packageCode || initialData?.tag || "",
      investmentAmount: initialData?.investmentAmount ?? "",
      goatCount: initialData?.goatCount ?? initialData?.minimumQuantity ?? "",
      goatUnitCost: initialData?.goatUnitCost ?? initialData?.pricePerUnit ?? "",
      managementFee: initialData?.managementFee ?? "",
      investorSharePercentage: initialData?.investorSharePercentage ?? initialData?.estimatedReturn ?? "",
      cycleDurationMonths: initialData?.cycleDurationMonths ?? 3,
      description: initialData?.description || "",
      riskNote: initialData?.riskNote || "",
      active: getActive(initialData || { active: true }),
      published: getPublished(initialData || {}),
    });
  }, [initialData, isOpen]);

  if (!isOpen) return null;

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setForm((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const goatCount = optionalNumber(form.goatCount);
    const goatUnitCost = optionalNumber(form.goatUnitCost);
    const investorShare = optionalNumber(form.investorSharePercentage);
    const payload = {
      id: initialData?.id,
      name: form.name,
      packageCode: form.packageCode || null,
      tag: form.packageCode || null,
      investmentAmount: optionalNumber(form.investmentAmount),
      goatCount,
      minimumQuantity: goatCount,
      goatUnitCost,
      pricePerUnit: goatUnitCost,
      managementFee: optionalNumber(form.managementFee),
      investorSharePercentage: investorShare,
      estimatedReturn: investorShare,
      cycleDurationMonths: optionalNumber(form.cycleDurationMonths),
      description: form.description,
      riskNote: form.riskNote,
      active: Boolean(form.active),
      featured: Boolean(form.published),
      published: Boolean(form.published),
    };
    onSave(initialData?.id, payload);
  };

  return (
    <div className="pkg-modal-bg" onClick={onClose}>
      <div className="pkg-modal" onClick={(event) => event.stopPropagation()}>
        <div className="pkg-modal-head">
          <h2 className="pkg-modal-title">{initialData ? "Edit Linked Package" : "Add Linked Package"}</h2>
          <button className="pkg-close" onClick={onClose} type="button">×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="pkg-form-grid">
            <div className="pkg-form-group">
              <label className="pkg-label">Package Name</label>
              <input className="pkg-input" name="name" value={form.name || ""} onChange={handleChange} required />
            </div>
            <div className="pkg-form-group">
              <label className="pkg-label">Package Code</label>
              <input className="pkg-input" name="packageCode" value={form.packageCode || ""} onChange={handleChange} placeholder="GOAT-100" />
            </div>
            <div className="pkg-form-group">
              <label className="pkg-label">Investment Amount</label>
              <input className="pkg-input" type="number" name="investmentAmount" value={form.investmentAmount ?? ""} onChange={handleChange} required />
            </div>
            <div className="pkg-form-group">
              <label className="pkg-label">Goat Count</label>
              <input className="pkg-input" type="number" name="goatCount" value={form.goatCount ?? ""} onChange={handleChange} />
            </div>
            <div className="pkg-form-group">
              <label className="pkg-label">Goat Unit Cost</label>
              <input className="pkg-input" type="number" name="goatUnitCost" value={form.goatUnitCost ?? ""} onChange={handleChange} />
            </div>
            <div className="pkg-form-group">
              <label className="pkg-label">Management Fee</label>
              <input className="pkg-input" type="number" name="managementFee" value={form.managementFee ?? ""} onChange={handleChange} />
            </div>
            <div className="pkg-form-group">
              <label className="pkg-label">Investor Share %</label>
              <input className="pkg-input" type="number" name="investorSharePercentage" value={form.investorSharePercentage ?? ""} onChange={handleChange} />
            </div>
            <div className="pkg-form-group">
              <label className="pkg-label">Cycle Duration Months</label>
              <input className="pkg-input" type="number" name="cycleDurationMonths" value={form.cycleDurationMonths ?? ""} onChange={handleChange} />
            </div>
            <div className="pkg-form-group full">
              <label className="pkg-label">Description</label>
              <textarea className="pkg-textarea" name="description" value={form.description || ""} onChange={handleChange} />
            </div>
            <div className="pkg-form-group full">
              <label className="pkg-label">Risk Note</label>
              <textarea className="pkg-textarea" name="riskNote" value={form.riskNote || ""} onChange={handleChange} />
            </div>
          </div>

          <div className="pkg-checks">
            <label><input type="checkbox" name="active" checked={Boolean(form.active)} onChange={handleChange} /> Active</label>
            <label><input type="checkbox" name="published" checked={Boolean(form.published)} onChange={handleChange} /> Published</label>
          </div>

          <div className="pkg-actions" style={{ justifyContent: "flex-end", marginTop: "1.4rem" }}>
            <button className="pkg-btn pkg-btn-secondary" onClick={onClose} type="button">Cancel</button>
            <button className="pkg-btn pkg-btn-primary" type="submit" disabled={saving}>{saving ? "Saving..." : "Save Package"}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default function PackageManagementPage() {
  const [summary, setSummary] = useState({ packages: [], investmentTrend: [] });
  const [packages, setPackages] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingPackage, setEditingPackage] = useState(null);

  const totalPages = Math.max(1, Math.ceil(packages.length / pageSize));
  const visiblePackages = useMemo(() => packages.slice(page * pageSize, page * pageSize + pageSize), [packages, page, pageSize]);

  const loadPackages = async () => {
    setLoading(true);
    setError(null);
    try {
      let data;
      try {
        data = await apiService.getLinkedSummary();
      } catch (linkedError) {
        console.warn("Linked package summary failed, using fallback:", linkedError);
        data = await apiService.getFallbackPackages();
      }
      const packageList = Array.isArray(data?.packages) ? data.packages : [];
      setSummary(data || {});
      setPackages(packageList);
      setPage(0);
    } catch (err) {
      console.error(err);
      setError(err.message || "Failed to load linked packages.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPackages();
  }, []);

  const openCreate = () => {
    setEditingPackage(null);
    setModalOpen(true);
  };

  const handleSave = async (id, payload) => {
    setSaving(true);
    setError(null);
    try {
      if (id) await apiService.updatePackage(id, payload);
      else await apiService.createPackage(payload);
      setModalOpen(false);
      setEditingPackage(null);
      await loadPackages();
    } catch (err) {
      console.error(err);
      setError(err.message || "Package save failed.");
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (pkg) => {
    const id = pkg.id || pkg.packageId;
    if (!id) return;
    if (!window.confirm(`Delete/disable ${pkg.name || pkg.packageName || "this package"}?`)) return;
    setLoading(true);
    setError(null);
    try {
      await apiService.deletePackage(id);
      await loadPackages();
    } catch (err) {
      console.error(err);
      setError(err.message || "Package delete failed.");
    } finally {
      setLoading(false);
    }
  };

  const sourceText = summary.source === "new-investor-backend" ? "Linked with new investor backend" : "Old backend fallback";

  return (
    <div className="pkg-page">
      <Styles />
      <div className="pkg-header">
        <div>
          <h1 className="pkg-title">Manage Packages</h1>
          <div className="pkg-subtitle">{sourceText}</div>
        </div>
        <div className="pkg-actions">
          <button className="pkg-btn pkg-btn-secondary" onClick={loadPackages} disabled={loading}>Refresh</button>
          <button className="pkg-btn pkg-btn-primary" onClick={openCreate}>Add New Package</button>
        </div>
      </div>

      {error && <div className="pkg-alert">{error}</div>}

      <div className="pkg-summary-grid">
        <StatCard label="Total Package Invested" value={money(summary.totalPackageInvested)} />
        <StatCard label="Total Investors" value={safeNumber(summary.totalInvestors).toLocaleString("en-IN")} />
        <StatCard label="Investment Count" value={safeNumber(summary.investmentCount).toLocaleString("en-IN")} />
        <StatCard label="Total Packages" value={safeNumber(summary.totalPackages ?? packages.length).toLocaleString("en-IN")} />
        <StatCard label="Active / Published" value={`${safeNumber(summary.activePackages)} / ${safeNumber(summary.publishedPackages)}`} />
      </div>

      <TrendBars trend={summary.investmentTrend} />

      <div className="pkg-table-wrap">
        <table className="pkg-table">
          <thead>
            <tr>
              <th>Package</th>
              <th>Investment Amount</th>
              <th>Goats</th>
              <th>Unit Cost</th>
              <th>Total Invested</th>
              <th>Investors</th>
              <th>Investments</th>
              <th>Pending / Running</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="10">Loading linked packages...</td></tr>
            ) : visiblePackages.length === 0 ? (
              <tr><td colSpan="10">No packages found from the linked backend.</td></tr>
            ) : (
              visiblePackages.map((pkg) => {
                const id = pkg.id || pkg.packageId;
                const active = getActive(pkg);
                const published = getPublished(pkg);
                return (
                  <tr key={id || pkg.name}>
                    <td>
                      <div className="pkg-name">{safeText(pkg.name || pkg.packageName)}</div>
                      <div className="pkg-code">{safeText(pkg.packageCode || pkg.tag)}</div>
                    </td>
                    <td>{money(pkg.investmentAmount ?? pkg.pricePerUnit)}</td>
                    <td>{safeText(pkg.goatCount ?? pkg.minimumQuantity)}</td>
                    <td>{money(pkg.goatUnitCost ?? pkg.pricePerUnit)}</td>
                    <td>{money(pkg.totalPackageInvested)}</td>
                    <td>{safeNumber(pkg.totalInvestors).toLocaleString("en-IN")}</td>
                    <td>{safeNumber(pkg.investmentCount).toLocaleString("en-IN")}</td>
                    <td>{safeNumber(pkg.pendingInvestments)} / {safeNumber(pkg.runningInvestments)}</td>
                    <td>
                      <span className={`pkg-badge ${active ? "pkg-badge-active" : "pkg-badge-inactive"}`}>{active ? "Active" : "Inactive"}</span>
                      {published && <span className="pkg-badge pkg-badge-published">Published</span>}
                    </td>
                    <td>
                      <div className="pkg-row-actions">
                        <button className="pkg-mini-btn" onClick={() => { setEditingPackage(pkg); setModalOpen(true); }}>Edit</button>
                        <button className="pkg-mini-btn pkg-btn-danger" onClick={() => handleDelete(pkg)}>Delete</button>
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      <div className="pkg-pagination">
        <button onClick={() => setPage((p) => Math.max(0, p - 1))} disabled={page === 0}>Previous</button>
        <span>Page {packages.length === 0 ? 0 : page + 1} of {packages.length === 0 ? 0 : totalPages}</span>
        <button onClick={() => setPage((p) => Math.min(totalPages - 1, p + 1))} disabled={page + 1 >= totalPages}>Next</button>
      </div>

      <PackageFormModal
        isOpen={modalOpen}
        initialData={editingPackage}
        onClose={() => { setModalOpen(false); setEditingPackage(null); }}
        onSave={handleSave}
        saving={saving}
      />
    </div>
  );
}
